{
  "longPressMessage": "Podržením tlačítka otevřete náhled"
}
